import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UmbracoHttpClient } from "@e-forsyning/common/http";
import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";
import { MapMapper } from "./map.mapper";
import { map, Observable } from "rxjs";
import { MapDefinition } from "../model/map.model";
import { MapDefinitionDto } from "../model/map.dto";

@Injectable({ providedIn: "root" })
export class MapRepository {
    constructor(
        private readonly http: UmbracoHttpClient,
        private readonly mapper: MapMapper
    ) {}

    public selectKonfiguration(nodeId: number): Observable<MapDefinition> {
        return this.http.hentSideDataForId<MapDefinitionDto>(nodeId).pipe(map((data) => this.mapper.dtoToMapDefinitioner(data)));
    }
}
